import { Widget } from "blue-widgets";

class Scrollto extends Widget {
  constructor(el) {
    super(el);
    this.init();
    this.scroll = this.scroll.bind(this);
  }

  init() {
    this.el.addEventListener("click", this.scroll, false);
    this.el.addEventListener("keydown", this.handleSpacebar, false);
    // Make the element focusable by adding the 'tabindex' attribute
    this.el.setAttribute("tabindex", "0");
  }

  scroll(e) {
    e.preventDefault();
    const targetId = e.target.getAttribute("href");
    const targetElement = document.querySelector(targetId);

    if (targetElement) {
      // Calculate the final position for scrolling
      const scrollPosition =
        targetElement.getBoundingClientRect().top +
        window.scrollY - 124;

      // Scroll to the target element with the offset
      window.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });

      // Set focus on the target element after scrolling
      targetElement.focus();
    }
  }

  handleSpacebar(e) {
    if (e.key === 32) {
      e.preventDefault();

      const clickEvent = new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      });

      this.dispatchEvent(clickEvent);
    }
  }

  beforeRemove() {
    this.el.removeEventListener("click", this.scroll, false);
    this.el.removeEventListener("keydown", this.handleSpacebar, false);
  }
}

export default Scrollto;
